import type { PhoneWithCountryCode } from '@/services/forms/types'
import type { UserRole, UserStatus } from '@/services/domain/user/types'
import type {
  SubAccountPermissionsAccount,
  SubAccountPermissionsActions,
  SubAccountPermissionsChannels,
  SubAccountPermissionsContacts,
  SubAccountPermissionsMessaging,
  SubAccountPermissionsReporting,
  SubAccountPermissionsServices,
} from '@/data/models/domain/SubAccountPermissions'

export interface SubAccountEditPermissionsFormScheme {
  actionsPermissions: SubAccountPermissionsActions
  messagingPermissions: SubAccountPermissionsMessaging
  channelsPermissions: SubAccountPermissionsChannels
  contactsPermissions: SubAccountPermissionsContacts
  servicesPermissions: SubAccountPermissionsServices
  accountPermissions: SubAccountPermissionsAccount
  reportingPermissions: SubAccountPermissionsReporting
}

interface InviteSubAccountUser {
  email: string
  role: UserRole
}
export interface InviteSubAccountFormScheme {
  invites: InviteSubAccountUser[]
}

export enum AuditLogCategory {
  api = 'API',
  error = 'Error',
  signUp = 'Sign Up',
  webSms = 'Web SMS',
  account = 'Account',
  payment = 'Payment',
  numbers = 'Numbers',
  smsChat = 'SMS Chat',
  settings = 'Settings',
  contacts = 'Contacts',
  templates = 'Templates',
  backOffice = 'Back Office',
  emailToSms = 'Email to SMS',
  carrierLookup = 'Carrier Lookup',
}

export enum AuditLogSource {
  iosApp = 'iOS App',
  webApp = 'Web App',
  unknown = 'Unknown',
  carreraApp = 'Carrera App',
  androidApp = 'Android App',
  apiV2 = 'API v2',
}

export type SubAccountImportDetailsFailedFormSchema = {
  firstName: string
  lastName: string
  phone: PhoneWithCountryCode
  email: string
  role: UserRole
}

export type SubAccountImport = {
  id: string
  firstName: string
  lastName: string
  phone: string
  email: string
  role: UserRole
}

export type SubAccountFetchFilter = {
  statuses?: UserStatus[]
  includeParent?: boolean
  includeSelf?: boolean
  includeRemoved?: boolean
}

export type SubAccountImportValidationResultDetails = {
  email: string[]
}

export const AUDIT_LOG_USER_FILTER_NAME = 'user' as const
